import { Outlet } from 'react-router';
import { Shell, type NavGroup } from '../ui/Shell';
import { useAuth } from '../auth/AuthProvider';
import { roleLabel } from '../lib/roles.js';
import { liveCount, normaliseBoard } from '../lib/board.js';
import { useOpsBoard, useOpsRiders, useOpsShops } from './queries';
import { needsVerification } from './shops/lib.js';

export function OpsLayout() {
  const { me } = useAuth();
  const board = useOpsBoard();
  const riders = useOpsRiders();
  const shops = useOpsShops();

  const live = board.data ? liveCount(normaliseBoard(board.data)) : null;
  const online = riders.data ? riders.data.filter((r) => r.online).length : null;
  const pending = shops.data ? shops.data.filter((s) => needsVerification(s) || s.status === 'pending').length : 0;

  const groups: NavGroup[] = [
    {
      items: [
        { to: '/ops', label: 'Overview', icon: 'home', end: true },
        { to: '/ops/live', label: 'Live orders', icon: 'receipt', count: live },
        { to: '/ops/riders', label: 'Riders & dispatch', icon: 'pin', count: online },
      ],
    },
    {
      scope: 'Marketplace',
      items: [
        { to: '/ops/shops', label: 'Shops', icon: 'bag', count: pending ? `${pending} to check` : null },
        { to: '/ops/products', label: 'Products', icon: 'box' },
        { to: '/ops/categories', label: 'Categories', icon: 'list' },
        { to: '/ops/customers', label: 'Customers', icon: 'person' },
        { to: '/ops/catalogue', label: 'Catalogue rules', icon: 'rules' },
        { to: '/ops/ads', label: 'Ads', icon: 'monitor' },
      ],
    },
    {
      scope: 'Money',
      items: [
        { to: '/ops/payments', label: 'Payments & COD', icon: 'cash' },
        { to: '/ops/catch-weight', label: 'Catch-weight', icon: 'scale' },
        { to: '/ops/refunds', label: 'Refunds', icon: 'refund' },
        { to: '/ops/payouts', label: 'Payouts', icon: 'chart' },
      ],
    },
    {
      scope: 'Setup',
      items: [
        { to: '/ops/zones', label: 'Zones & fees', icon: 'globe' },
        { to: '/ops/maps', label: 'Map health', icon: 'pin' },
        { to: '/ops/express', label: 'Express', icon: 'bolt' },
        { to: '/ops/reports', label: 'Reports', icon: 'pie' },
        { to: '/ops/team', label: 'Team', icon: 'team' },
        { to: '/ops/settings', label: 'Settings', icon: 'gear' },
      ],
    },
  ];

  return (
    <Shell label="Ops" brand="Ops" brandSub="SUPER-ADMIN" groups={groups} roleText={roleLabel(me) || 'OPS'}>
      <Outlet />
    </Shell>
  );
}
